import styled from 'styled-components';
import { MainAccordion } from 'modules/components/common';

export function AskAndAppreciate() {
  const content = (
    <div className="appreciate-content_container">
      <p className="question">
        Question and Recommendations:
        <br />
        1.{' '}
        <span className="gray-text">
          Appreciate SMBG data gathering and Encourage to do more SMBG if
          necessary.
          <br />
          <br />
        </span>
        2.{' '}
        <span className="gray-text">
          Ask about:
          <br />. Pre-meal & Post Meal timing
        </span>
        <br />
        . The possibility of shared glucometer data and/or multiple glucometers
        <br />
        <span className={'gray-text'}>
          . Serious hypo & hyperglycemic events
        </span>
        <br />. Any changes in lifestyle or medications
      </p>
    </div>
  );

  return (
    <StyledApreciate>
      <div className="mobile-view">
        <MainAccordion header="Appreciate & ask">{content}</MainAccordion>
      </div>
      <div className="web-view">
        <p className="web-view_title">Appreciate & ask</p>
        <div className="web-view_content">{content}</div>
      </div>
    </StyledApreciate>
  );
}

const StyledApreciate = styled.div`
  width: 100%;
  line-height: 25px;
  .appreciate-content_container {
    width: 100%;
    direction: ltr;
    padding: 60px 19px 120px;
  }
  .question {
    color: #753cbe;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
  }
  .gray-text {
    color: #4e4e4e;
  }
  .web-view_title {
    width: max-content;
    color: #753cbe;
    font-size: 28px;
    font-family: 'dana-bold';
    line-height: 43.88px;
    letter-spacing: 1px;
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #d8d8d8;
    margin: auto;
  }
  .web-view {
    display: none;
  }
  @media screen and (min-width: 1024px) {
    background: #f9fafb;
    .appreciate-content_container {
      padding: 64px 0 0;
    }
    .web-view {
      padding: 50px 66px 48px;
      display: block;
    }
    .mobile-view {
      display: none;
    }
    .question {
      line-height: 36px;
    }
  }
`;
